export default __webpack_public_path__ + "static/media/Chilled Water Pipeline work.eb4983de.jpeg";